/**
 * Angular imports.
 */
import { Component, OnInit, OnDestroy } from '@angular/core';

/**
 * Service imports.
 */
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
import { FunCollectionService } from 'src/app/common/common-functions/fun-collection.service';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';
/**
 * sdk imports 
 */
import { Analytics } from 'analytics2.0';
import { ENTRY, EXIT } from 'analytics2.0/dist/core/constants/analytic.interface';
import { PRODUCT_TYPE_CONSTANT_NAME, SCREEN_NAME } from 'src/app/constants/app.constants';
/**
 * Mobile Search Component.
 */
@Component({
  selector: 'app-mobile-search',
  templateUrl: './mobile-search.component.html',
  styleUrls: ['./mobile-search.component.scss']
})
export class MobileSearchComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public masterData: any;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * screen start time
   */
  private startTime = 0;
  /**
   * Necessary instances
   */
  constructor(public masterService: MasterserviceService, private dss: DataStorageService,private fcs: FunCollectionService, private analyticSdk: Analytics) { }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.dss.feedDetailBack = false;
    this.dss.feedDetailOther = true;
    this.masterData = this.masterService.masterApiData;
    this.startTime = new Date().getTime();
    const entryData: ENTRY = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.SEARCH,
      entity_code: 0,
      current_screen_name: SCREEN_NAME.SEARCH_SCREEN,
      source: this.fcs.currentScreename ?? localStorage.getItem('triggerSource'),
      start_time: new Date().getTime()
    }
    this.analyticSdk.analyticService.ENTRY(entryData);
    this.fcs.currentScreename = SCREEN_NAME.SEARCH_SCREEN;
  }


  /**
   * Unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.startTime > 0) {
      const exitData: EXIT = {
        entity_type: PRODUCT_TYPE_CONSTANT_NAME.SEARCH,
        entity_code: 0,
        start_time: this.startTime,
        end_time: new Date().getTime(),
        current_screen_name: SCREEN_NAME.SEARCH_SCREEN
      }
      this.analyticSdk.analyticService.EXIT(exitData);
      this.fcs.currentScreename = SCREEN_NAME.SEARCH_SCREEN;
    }
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    this.dss.feedDetailBack = true;
    this.dss.feedDetailOther = false;
  }
}
